var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('smooth-scrollbar',[_c('div',{staticClass:"group-list",staticStyle:{"margin":"0 1.4rem","height":"55vh"}},_vm._l((_vm.orthos),function(group,i){return _c('group',{key:i,attrs:{"group":group,"index":i}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }